import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorSilver = createSvgIcon(
  <circle cx="10" cy="10" fill="#B5B5B5" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorSilver',
);
